import {ajax} from '../utils/ajaxHelper';

async function getImageMetadata({propertyApiUrl, listingId}) {
    const url = `/pdp/imageMetadata?propertyApiUrl=${propertyApiUrl}&listingId=${listingId}`;

    return ajax(url);
}

export default getImageMetadata;
export {getImageMetadata};
